// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menubutton{margin-left:0.5rem;display:flex;align-items:center;--tw-text-opacity:1;color:rgb(34 41 47 / var(--tw-text-opacity))}@media (min-width: 768px){.menubutton{display:none}}.menubutton button{display:flex;height:2rem;width:2rem;align-items:center;justify-content:center}.menubutton button:focus{outline:2px solid transparent;outline-offset:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
